function isAnimationControls(v) {
  return v !== null && typeof v === "object" && typeof v.start === "function";
}
export {
  isAnimationControls
};
